import React, { FC } from "react";
import { format } from "date-fns";
import { getScheduleStatusTextColor } from "../utils";
import { TaskCalendarStatus } from "../types";

interface CalendarEventContentProps {
  title: string;
  status: TaskCalendarStatus;
  start: Date | null;
  end: Date | null;
}

export const CalendarEventContent: FC<CalendarEventContentProps> = ({
  title,
  status,
  start,
  end,
}) => {
  const timeRange =
    start && end
      ? `${format(start, "yyyy-MM-dd HH:mm")} - ${format(
          end,
          "yyyy-MM-dd HH:mm"
        )}`
      : "";

  const statusTextColor = getScheduleStatusTextColor(status);

  return (
    <div
      className="flex flex-col w-full h-full cursor-pointer"
      title={`${title} (${timeRange})`}
    >
      <div className="flex items-center gap-1">
        <span className="w-2 h-2 rounded-full bg-white opacity-80" />
        <span className={statusTextColor}>{title}</span>
      </div>
      <div
        className={`text-[10px] opacity-90 pl-4 leading-tight ${statusTextColor}`}
      >
        {String(status)}
      </div>
    </div>
  );
};
